import { formatFechaHora, formatUsuarioDisplay } from '../../utils';

const BOX = {
    backgroundColor: '#fff',
    border: '1px solid #dee2e6',
    borderRadius: 6,
    padding: '10px 12px',
};

const TimelineMessageCard = ({
    accentColor = '#215732',
    badge,
    usuario,
    fechaHora,
    body,
}) => (
    <div
        style={{
            ...BOX,
            borderLeftWidth: 3,
            borderLeftStyle: 'solid',
            borderLeftColor: accentColor,
        }}
    >
        {badge ? (
            <span
                className="d-block text-uppercase mb-2"
                style={{
                    color: accentColor,
                    letterSpacing: '.4px',
                    fontSize: '0.7rem',
                    fontWeight: 600,
                }}
            >
                {badge}
            </span>
        ) : null}
        <div className="d-flex flex-wrap justify-content-between align-items-baseline gap-2 mb-2">
            <span
                className="fw-semibold"
                style={{ fontSize: '0.8rem', color: '#495057' }}
            >
                {formatUsuarioDisplay(usuario)}
            </span>
            <span
                style={{
                    fontSize: '0.75rem',
                    color: '#6c757d',
                    whiteSpace: 'nowrap',
                }}
            >
                {fechaHora ? formatFechaHora(fechaHora) : '-'}
            </span>
        </div>
        <span
            style={{
                display: 'block',
                fontSize: '0.85rem',
                color: '#333',
                lineHeight: 1.55,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
            }}
        >
            {body}
        </span>
    </div>
);

export default TimelineMessageCard;
